import { Icon } from '@graftcode/design-system'
import { Values } from '@graftcode/design-system'

export const PACKAGE_MANAGER_ICON: Values<typeof Icon> = Icon.BoxRegular
